import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

/**
 * Shortcut to organisation settings for the current org (no list nesting).
 */
const MyOrganisationRedirect = ({ currentOrganisation }) => {
  if (!currentOrganisation) {
    return <Redirect to='/' />;
  }
  return <Redirect to={`/organisations/${currentOrganisation}`} />;
};

const mapStateToProps = (state) => ({
  currentOrganisation: state.currentOrganisation,
});

export default connect(mapStateToProps)(MyOrganisationRedirect);
